export const SANR_DISCORD = 'https://discord.gg/YtqHEYEYTF';
export const SANR_TELEGRAM = 'https://t.me/sanr_protocol';
export const SANR_TWITTER = 'https://twitter.com/Sanr_App';
